import React, { useEffect, useState } from "react";
import "../css/Login.css";
import loginImg from "../assets/images/Login.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ChangePassswordHooks from "../hooks/ChangePasswordHooks";

const ChangePasssword = () => {
  let {
    showPassword,
    togglePasswordVisibility,
    formData,
    loading,
    handleLogin,
    handleInputChange,
    togglePasswordVisibility2,
    showPassword2,
    togglePasswordVisibility3,
    showPassword3,
  } = ChangePassswordHooks();

  return (
    <>
      <section className="login ms-md-2 ms-5">
        <div className="row align-items-center justify-content-center w-100 m-0">
          <form className="col-12 col-md-6 mb-5" onSubmit={handleLogin}>
            <div className="text-center loginText">
              <h4>Change Your Password</h4>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="input" className="text">
                Current Password:
              </label>
              <input
                type={showPassword ? "text" : "password"}
                onChange={handleInputChange}
                value={formData.currentPassword}
                minLength={8}
                required
                placeholder="• • • • • •"
                name="currentPassword"
                className="input"
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "63%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </span>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="input" className="text">
                New Password:
              </label>
              <input
                type={showPassword2 ? "text" : "password"}
                onChange={handleInputChange}
                value={formData.newPassword}
                minLength={8}
                required
                placeholder="• • • • • •"
                name="newPassword"
                className="input"
              />
              <span
                onClick={togglePasswordVisibility2}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "63%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword2 ? faEyeSlash : faEye} />
              </span>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="input" className="text">
                Confirm Password:
              </label>
              <input
                type={showPassword3 ? "text" : "password"}
                onChange={handleInputChange}
                value={formData.confirmPassword}
                minLength={8}
                required
                placeholder="• • • • • •"
                name="confirmPassword"
                className="input"
              />
              <span
                onClick={togglePasswordVisibility3}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "63%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword3 ? faEyeSlash : faEye} />
              </span>
            </div>

            <div className="forgetPassword mt-3">
              <button
                type="submit"
                disabled={loading}
                className="btn w-100 loginbtn btn-dark"
              >
                {loading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}{" "}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ChangePasssword;